import { useMutation, useQueryClient } from "@tanstack/react-query";
import { omitBy } from "lodash";
import api from "../../../services/api";
import { NotificationsLevel } from "../../../lib/enums";
import { show } from "../../../notifications/notifications";
import { MenuItems, AddedTagResponse } from "../../@types";
import { Selections, Sort } from "../../../modules/search/@types";
import { formatTagNotificationMessage } from "../utils";
import { generateQueryWithSelections } from "../../../modules/search/util";
import { USER_TAGS_KEY } from "../queryKeys";

type tagAllSearchRequestParams = {
  sort: Sort | undefined;
  selections: Selections | undefined;
  query: string;
  selectedTags: MenuItems;
};

const useSetAllTagsSearch = () => {
  const tagAllSearch = ({
    sort,
    selections,
    query,
    selectedTags
  }: tagAllSearchRequestParams) => {
    const transformedTags = selectedTags.map(item => item.value);
    const data = omitBy(
      {
        query: generateQueryWithSelections(selections, query),
        sort: `${sort?.field} ${sort?.direction}`
      },
      value => !value
    );
    Object.assign(data, { tags: transformedTags });
    return api.tagAllSearch(data);
  };

  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: tagAllSearch,
    onMutate: () => {
      show({
        level: NotificationsLevel.INFO,
        message: "Adding Tags..."
      });
    },
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({ queryKey: [USER_TAGS_KEY] });
      const setAllAddedTags = data?.result.map(
        (item: AddedTagResponse) => item.added_tag
      );
      const message = formatTagNotificationMessage(
        "Added tag",
        setAllAddedTags
      );
      show({
        level: NotificationsLevel.INFO,
        message
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: "Something went wrong. Please try again."
      });
    }
  });

  return { mutate };
};

export default useSetAllTagsSearch;
